const OrganizationStatus = {
  PendingApproval: 'PendingApproval',
  Declined: 'Declined',
  Active: 'Active',
  Disabled: 'Disabled'
};

export default OrganizationStatus;
